const ConsentSucessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <circle cx="40" cy="40" r="40" fill="#449F52" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.3746 29.0414C56.0418 29.7085 56.0418 30.7902 55.3746 31.4573L36.583 50.249C35.9158 50.9161 34.8342 50.9161 34.167 50.249L25.6254 41.7073C24.9582 41.0402 24.9582 39.9585 25.6254 39.2914C26.2925 38.6242 27.3742 38.6242 28.0413 39.2914L35.375 46.6251L52.9587 29.0414C53.6258 28.3742 54.7075 28.3742 55.3746 29.0414Z"
        fill="white"
      />
    </svg>
  );
};
export default ConsentSucessIcon;
